{
  "version": 1,
  "asset_id": "766528eb-53a6-4e53-ba55-6bc252efbfab",
  "project_id": "e3708065-dee2-4f65-a2de-1d1b02caf785",
  "url": "/__l5e/assets-v1/766528eb-53a6-4e53-ba55-6bc252efbfab/the-crystallized-mind-cover.png",
  "r2_key": "a/v1/e3708065-dee2-4f65-a2de-1d1b02caf785/766528eb-53a6-4e53-ba55-6bc252efbfab/the-crystallized-mind-cover.png",
  "original_filename": "the-crystallized-mind-cover.png",
  "size": 2938028,
  "content_type": "image/png",
  "created_at": "2026-07-17T00:05:06Z"
}
